import { prop } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

import { useCurrentFormFactor } from 'js/app/hooks/device/hooks/useMediaQuery';
import { useFilterByUserSegmentation } from 'js/app/hooks/useSegmentation';
import { isWebpSupported } from 'js/app/utils/common.util';

export const getEnterDrawOptions = (slide) => ({
    immediate: true,
    mainTag: slide?.tags?.mainTag,
    secondaryTags: slide?.tags?.secondaryTags?.map(tagObj => tagObj?.secondaryTag),
    ctaConfiguration: slide?.cta?.ctaConfiguration,
    gameCode: slide?.cta?.gameCode,
    navigateUrl: slide?.cta?.url,
    showLoginForGuest: true,
    showInfos: true,
    ...slide?.contactPopup || {},
    ...slide?.popupMessages || {}
});

export const useGetSlideOverride = (slide) => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const filterByUserSegmentation = useFilterByUserSegmentation();
    const currentFormFactor = useCurrentFormFactor().toLowerCase();

    const targetSlideImages = slide?.imageOverrides?.find(overrideSlide => {
        return filterByUserSegmentation(overrideSlide.visibility) &&
            overrideSlide.formFactor.includes(currentFormFactor);
    });

    if (isLoggedIn) {
        return {
            slideUrl: targetSlideImages
                ? targetSlideImages.slideUrl || targetSlideImages.guestSlideUrl
                : slide.slideUrl || slide.guestSlideUrl,
            fallbackSlideUrl: targetSlideImages
                ? targetSlideImages.fallbackSlideUrl || targetSlideImages.guestFallbackSlideUrl
                : slide.fallbackSlideUrl || slide.guestFallbackSlideUrl
        };
    }

    return {
        slideUrl: targetSlideImages
            ? targetSlideImages.guestSlideUrl || targetSlideImages.slideUrl
            : slide.guestSlideUrl || slide.slideUrl,
        fallbackSlideUrl: targetSlideImages
            ? targetSlideImages.guestFallbackSlideUrl || targetSlideImages.fallbackSlideUrl
            : slide.guestFallbackSlideUrl || slide.fallbackSlideUrl
    };
};

export const getSlideImage = (slide) => {
    const { slideUrl, fallbackSlideUrl } = slide;
    const isWebpImage = slideUrl
        .split('.')
        .pop()
        .toLowerCase() === 'webp';

    return isWebpImage && !isWebpSupported()
        ? fallbackSlideUrl
        : slideUrl;
};
